module.exports = __webpack_public_path__ + "src/assets/games/32/32.jpg";